import {
  Component,
  inject,
  input
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { RendezVous } from '../../../../core/model/rendez-vous.model';
import { emulateClick } from '../core/a11y';
import { DrawerService } from '../drawer/drawer.service';
import { HoverGradientDirective } from '../shared/directives/hover-gradient.directive';
import { CenterService } from '../shared/services/center.service';

@Component({
  selector: 'app-confirm-cancel-spa',
  imports: [
    HoverGradientDirective,
    NgxTolgeeModule,
  ],
  templateUrl: './confirm-cancel-spa.component.html'
})
export class ConfirmCancelSpaComponent {
  readonly emulateClick = emulateClick;
  drawerService = inject(DrawerService);
  centerService = inject(CenterService);
  rendezVous = input.required<RendezVous>()

}
